// extracted by mini-css-extract-plugin
module.exports = {"dvmg0qw":"dvmg0qw"};